export enum TourKey {
  CORE = 'coreV0',
  CORE_V1 = 'coreV1',
  CRM = 'crmV0',
  FINANCIAL_SHEETS = 'financialSheetsV0',
  NONE = 'none',
  PARTNERS = 'partnersV0',
  PROJECTS = 'projectsV0',
  SUPPLIERS = 'suppliersV0',
}
